module.exports = __webpack_public_path__ + "static/media/givenchy-l'interdit-big.5480c369.png";